import React from 'react';
import LanguageSelector from '@components/Header/LanguageSelector';
import LoginBtn from '@components/Header/LoginArea/LoginBtn';
import { useTranslation } from '@wix/fe-essentials-standalone';
import s from '../LoginArea.module.scss';

export interface NotLoggedinAreaProps {
  language?: string;
  pageName: string;
  isLessThan1000View: boolean;
}

const LoginDisplay = ({
  language = 'en',
  pageName,
  isLessThan1000View,
}: NotLoggedinAreaProps) => {
  const { t } = useTranslation();
  const loginButtonLabel = t('marketplace-header-btn-login');

  return (
    <>
      <li className={`${s.cell} ${s.desktop} ${s.right}`}>
        <LanguageSelector
          value={language}
          pageName={pageName}
          isLess1000View={isLessThan1000View}
          forceShowLanguageLabel={true}
          showSuffixIcon={true}
          hidePrefixIcon={true}
        />
      </li>
      <li className={`${s.cell} ${s.notLoggedIn} ${s.desktop} ${s.last} `}>
        <LoginBtn btnLoginLabel={loginButtonLabel} pageName={pageName} />
      </li>
    </>
  );
};

export default LoginDisplay;
